/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailInformationAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v10h-2V5.227l-8 7.111-8-7.111V18h8v2H2zm3.63 2L12 9.662 18.37 4z" />
        <path d="M17.998 14a4 4 0 1 1-.002 8.002A4 4 0 0 1 17.998 14zm-.498 6.5h1v-3h-1zm0-5v1h1v-1z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmailInformationAlt as EmailInformationAlt };
